module.exports = {
  decode: async () => true,
  parse: async () => true,
}
